import { useState, useCallback, FC } from 'react';
import intl from 'react-intl-universal';
import { Button, Icon } from '@getsynapse/design-system';
import SearchMembers from './components/SearchMembers/SearchMembers';
import { AddTeamMembersHandler } from 'types/store/learningTeam';

interface AddMembersProps {
  onAddUsers: AddTeamMembersHandler;
}

const AddMembers: FC<AddMembersProps> = ({ onAddUsers }) => {
  const [displaySearchMembers, setDisplaySearchMembers] = useState(false);

  const toggleDisplaySearchMembers = useCallback(() => {
    setDisplaySearchMembers((prev) => !prev);
  }, []);

  const onAddUsersWithClose = useCallback(
    async (usersIds: string[]) => {
      const response = await onAddUsers(usersIds);
      if (response && response.failedIds.length === 0) {
        toggleDisplaySearchMembers();
      }
      return response;
    },
    [onAddUsers, toggleDisplaySearchMembers]
  );

  if (displaySearchMembers) {
    return (
      <SearchMembers
        onCancel={toggleDisplaySearchMembers}
        onAddUsers={onAddUsersWithClose}
      />
    );
  }

  return (
    <div>
      <Button
        variant='tertiary'
        className='flex items-center gap-x-2'
        onClick={toggleDisplaySearchMembers}
      >
        <Icon name='add-circle' className='text-xl' />
        {intl.get('ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.ADD_MEMBER')}
      </Button>
    </div>
  );
};

export default AddMembers;
